import React from 'react'
import './footer.css'
import { FaFacebookF } from "react-icons/fa"
import { FaInstagram } from "react-icons/fa"
import { FaLinkedin } from "react-icons/fa"

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>BAJADI</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#skills">Skills</a></li>
        <li><a href="#projects">Projects</a></li>
        <li><a href="#expreinces">Experiences</a></li>
        <li><a href="#educations">Educations</a></li>
        <li><a href="#services">Services</a></li>
        <li><a href="#certificates">Certificates</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socails">
        <a href="https://facebook.com/profile.php?id=100028290729583" target='_blank'><FaFacebookF /></a>
        <a href="https://www.instagram.com/pi_poel/" target='_blank'><FaInstagram /></a>
        <a href="https://www.linkedin.com/in/mohamed-bajadi-788227280/" target='_blank'><FaLinkedin /></a>
      </div>

      <div className="footer__copyright">
        <small>
          &copy; Mohamed Bajadi. All rights reserved 2026
        </small>
      </div>

    </footer>
  )
}

export default Footer